export default {
  SUPPORT_AND_CONTACT: {
    name: 'Support & contact',
    code: 'onboarding__support_and_contact',
    description: 'Support & contact',
    is_required: false,
    is_deprecated: false,
    order: 1
  },
  GO_LIVE_DATES_AND_TRAININGS: {
    name: 'Go-live dates & trainings',
    code: 'onboarding__go_live_dates_and_trainings',
    description: 'Set up your go-live dates and schedule your training events',
    is_required: false,
    is_deprecated: false,
    order: 2
  },
  ACKNOWLEDGEMENTS: {
    name: 'Acknowledgements',
    code: 'onboarding__acknowledgements',
    description: 'Acknowledgements',
    is_required: true,
    is_deprecated: false,
    order: 3
  },
  KICKOFF_VIDEO_TRAINING: {
    name: 'Kickoff video training',
    code: 'onboarding__kickoff_video_training',
    description: 'Kickoff video training',
    is_required: false,
    is_deprecated: false,
    order: 4
  },
  BASIC_SETUP_CONFIRMATION: {
    name: 'Basic setup / confirmation',
    code: 'onboarding__basic_setup_confirmation',
    description: 'Set up your practice details',
    is_required: false,
    is_deprecated: false,
    order: 5
  },
  STAFF_AND_PERMISSIONS: {
    name: 'Staff & permissions',
    code: 'onboarding__staff_and_permissions',
    description: 'Invite team members',
    is_required: false,
    is_deprecated: false,
    order: 6
  },
  DELEGATION: {
    name: 'Delegation',
    code: 'onboarding__delegation',
    description: 'Delegate tasks to your staff',
    is_required: false,
    is_deprecated: false,
    order: 7
  },
  DATA_EXPORT: {
    name: 'Data export',
    code: 'onboarding__data_export',
    description: 'Data export',
    is_required: false,
    is_deprecated: false,
    order: 8
  },
  KICKOFF_LIVE_TRAINING: {
    name: 'Kickoff live working session',
    code: 'onboarding__kickoff_live_training',
    description: 'Kickoff live working session',
    is_required: false,
    is_deprecated: false,
    order: 9
  },
  FRONT_OFFICE_VIDEO_TRAINING: {
    name: 'Front office video training',
    code: 'onboarding__front_office_video_training',
    description: 'Front office video training',
    is_required: false,
    is_deprecated: false,
    order: 10
  },
  SCHEDULE_OF_FEES: {
    name: 'Schedule of fees',
    code: 'onboarding__schedule_of_fees',
    description: 'Welcome to schedule of fees',
    is_required: false,
    is_deprecated: false,
    order: 11
  },
  KIOSK_SETUP: {
    name: 'Kiosk setup',
    code: 'onboarding__kiosk_setup',
    description: 'Add kiosk verification code',
    is_required: false,
    is_deprecated: false,
    order: 12
  },
  HEALTHCARE_PROGRAM: {
    name: 'Healthcare program',
    code: 'onboarding__healthcare_program',
    description: 'Configure eligibility, payment program, and IncomeIQueue RCM',
    is_required: false,
    is_deprecated: false,
    order: 13
  },
  FRONT_OFFICE_LIVE_TRAINING: {
    name: 'Front office live working session',
    code: 'onboarding__front_office_live_training',
    description: 'Front office live working session',
    is_required: false,
    is_deprecated: false,
    order: 14
  },
  CLINICAL_VIDEO_TRAINING: {
    name: 'Clinical video training',
    code: 'onboarding__clinical_video_training',
    description: 'Clinical video training',
    is_required: false,
    is_deprecated: false,
    order: 15
  },
  CUSTOM_FORMS: {
    name: 'Custom forms',
    code: 'onboarding__custom_forms',
    description: 'Create custom forms',
    is_required: false,
    is_deprecated: false,
    order: 16
  },
  DATA_IMPORT: {
    name: 'Data import',
    code: 'onboarding__data_import',
    description: 'Start your automatic patient import process',
    is_required: false,
    is_deprecated: false,
    order: 17
  },
  E_PRESCRIBE_SETUP: {
    name: 'E-prescribing setup',
    code: 'onboarding__e_prescribe_setup',
    description: 'E-prescribing integration',
    is_required: false,
    is_deprecated: false,
    order: 18
  },
  CLINICAL_LIVE_TRAINING: {
    name: 'Clinical live working session',
    code: 'onboarding__clinical_live_training',
    description: 'Clinical live working session',
    is_required: false,
    is_deprecated: false,
    order: 19
  },
  BACK_OFFICE_VIDEO_TRAINING: {
    name: 'Back office video training',
    code: 'onboarding__back_office_video_training',
    description: 'Back office video training',
    is_required: false,
    is_deprecated: false,
    order: 20
  },
  CLEARINGHOUSE: {
    name: 'Myriad billing',
    code: 'onboarding__clearinghouse',
    description: 'Manage billing providers',
    is_required: false,
    is_deprecated: false,
    order: 21
  },
  BACK_OFFICE_LIVE_TRAINING: {
    name: 'Back office live working session',
    code: 'onboarding__back_office_live_training',
    description: 'Back office live working session',
    is_required: false,
    is_deprecated: false,
    order: 22
  },
  HARD_LAUNCH_VIDEO_TRAINING: {
    name: 'Hard launch video training',
    code: 'onboarding__hard_launch_video_training',
    description: 'Hard launch video training',
    is_required: false,
    is_deprecated: false,
    order: 23
  },
  HARD_LAUNCH_LIVE_TRAINING: {
    name: 'Hard launch live working session',
    code: 'onboarding__hard_launch_live_training',
    description: 'Hard launch live working session',
    is_required: false,
    is_deprecated: false,
    order: 24
  }
};
